import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchIncentive = createAsyncThunk("incentive/fetchIncentive", async (searchText) => {
  const response = await api.post("/incentive", { search: searchText });
  return response.data.data;
});

// Define the initial state and slice
const incentiveSlice = createSlice({
  name: "incentiveData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    error: null,
    successMessage: null,
  },
  reducers: {
    openIncentiveModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeIncentiveModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncentive.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIncentive.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchIncentive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { openIncentiveModal, closeIncentiveModal, clearError } = incentiveSlice.actions;
export default incentiveSlice.reducer;
export { incentiveSlice };
